module.exports = __webpack_public_path__ + "img/osterruhe.4a84ad9c.png";